module.exports = __webpack_public_path__ + "img/photo-45.f8c7372c.webp";